import { render, staticRenderFns } from "./insertAccessGroup.vue?vue&type=template&id=f8262666&scoped=true"
import script from "./insertAccessGroup.vue?vue&type=script&lang=js"
export * from "./insertAccessGroup.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f8262666",
  null
  
)

export default component.exports